import type { CreatePredictionRequest } from 'api/__GENERATED';
import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toPrediction } from './transformers/toPrediction';

// Sends a create-prediction request to Prediction_Create and returns the
// server-assigned Data.Projection. unitOfMeasureId is hard-coded to match the
// legacy newActualAPI.createForecast call until it becomes part of the user
// flow.
async function createForecast(args: {
  tenantId: string;
  zoneId: string;
  date: Time.Day;
  value: number;
}) {
  const { tenantId, zoneId, date, value } = args;

  const body: CreatePredictionRequest = {
    zoneId,
    year: date.year,
    monthNumber: date.month + 1,
    dayOfMonth: date.dayOfMonth,
    value,
    unitOfMeasureId: '952303DE-5041-44DE-9613-DF730AC7BA9B',
  };

  const apiCall = apiClient.Prediction_Create(body, {
    params: { tenantId },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to create forecast',
    },
    onSuccess: (dto) => {
      const projection = toPrediction(dto);
      return { projection };
    },
  });
}

export { createForecast };
